import { AttendeeRole } from '@/constants'

export const ROLES_WITH_ID = [AttendeeRole.WITNESS, AttendeeRole.GUARDIAN]

export const DR_TIMESTAMPS_CHAR_LIMIT = 5000

export const DR_SPELLINGS_CHAR_LIMIT = 5000

export const DR_NOTES_CHAR_LIMIT = 15000
